<div class="day-seller-producer">
  <div class="day-seller-producer__info">
    <bmcore-day-seller-producer-content [producer]="producer"></bmcore-day-seller-producer-content>
  </div>

  <div class="day-seller-producer__tracks">
    <div class="day-seller-producer__tracks-header">
      <h3 class="common-bmstv-title-1 common-bmstv-title-1--without-hover">Beats {{ producer?.beatmakerName }}</h3>
      <a
        class="common-bmstv-title-1 common-bmstv-title-1--highlight"
        routerLink="/bm/{{ producer?.beatmakerId }}/catalog"
      >
        View all
      </a>
    </div>

    @for (track of producer?.beats | slice: 0 : 4; track track) {
      <bmcore-track-item
        [track]="track"
        [isShowFavBtn]="true"
        (setPlaylistEvent)="setPlaylist()"
        [isTopSeller]="true"
        [appType]="'BMSTV'"
      >
      </bmcore-track-item>
    }
  </div>
</div>
